export default {
    methods: {
        print_windowPrint() {
            if (typeof window.print === 'function') {
                window.print();
            }
        },
    },
};
